import { UseQueryResult, useQuery } from "@tanstack/react-query";

import { InstrumentCatalogResponse, fetchInstrumentCatalog } from "@features/investments/api";

export const instrumentCatalogQueryKey = (ticker: string) => ["investments", "catalog", ticker] as const;

export function useInstrumentCatalogQuery(ticker: string): UseQueryResult<InstrumentCatalogResponse, Error> {
  return useQuery({
    queryKey: instrumentCatalogQueryKey(ticker),
    queryFn: () => fetchInstrumentCatalog(ticker),
    enabled: ticker.trim() !== "",
    retry: false,
  });
}
